// API Configuration Service
// Handles environment detection and API endpoint configuration

/**
 * Get the appropriate API base URL based on environment
 */
export const getApiBaseUrl = (): string => {
  // Check if we have an explicit environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Auto-detect based on current hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // Production
    if (hostname === 'koja-classics.com') {
      return 'https://koja-classics.com';
    }

    // Local development
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5000';
    }
  }

  // Default fallback (should not happen in production)
  return 'http://localhost:5000';
};

/**
 * API endpoints configuration
 */
export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  ENDPOINTS: {
    GAME_ENGINE: '/api/game-engine',
    AUTH: '/api/auth',
    HEALTH: '/api/health',
  },
} as const;

/**
 * Get authentication token from localStorage
 */
export const getAuthToken = (): string | null => {
  try {
    return localStorage.getItem('piToken') || localStorage.getItem('authToken');
  } catch (error) {
    console.warn('Could not access localStorage for auth token:', error);
    return null;
  }
};

/**
 * Check if we're in development environment
 */
export const isDevelopment = (): boolean => {
  return (
    process.env.NODE_ENV === 'development' ||
    (typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1'))
  );
};
